const loanPurposeList = [
{ key: "CONSOLIDATE_DEBT", text: "Debt Consolidation", label: "Debt Consolidation", index: "1" },
{ key: "HOME_IMPROVEMENT", text: "Home Improvement", label: "Home Improvement", index: "2" },
{ key: "MEDICAL_EXPENSE", text: "Medical Expense", label: "Medical Expense", plKey: "MEDICAL", index: "3" },
{ key: "AUTO_EXPENSE", text: "Auto Expense", label: "Auto Expense", plKey: "AUTO", index: "4" },
{ key: "OTHER", text: "Other", label: "Other", index: "11" }
];
const stateList = [
    { key: "Select", text: "All", label: "All", index: "0" },
    {key: "AL", text: "Alabama", label : "Alabama"},
    {key: "AK", text: "Alaska", label: "Alaska"},
    {key: "AS",text: "American Samoa",label: "American Samoa"},
    {key: "AZ",text: "Arizona",label: "Arizona"},
    {key: "AR",text: "Arkansas",label: "Arkansas"},
    {key: "CA",text: "California",label: "California"},
    {key: "CO",text: "Colorado",label: "Colorado"},
    {key: "CT",text: "Connecticut",label: "Connecticut"},
    {key: "DE",text: "Delaware",label: "Delaware"},
    {key: "DC",text: "District Of Columbia",label: "District Of Columbia"},
    {key: "FS",text: "Federated States Of Micronesia",label: "Federated States Of Micronesia"},
    {key: "FL",text: "Florida",label: "Florida"},
    {key: "GA",text: "Georgia",label: "Georgia"},
    {key: "GU",text: "Guam",label: "Guam"},
    {key: "HI",text: "Hawaii",label: "Hawaii"},
    {key: "ID",text: "Idaho",label: "Idaho"},
    {key: "IL",text: "Illinois",label: "Illinois"},
    {key: "IN",text: "Indiana",label: "Indiana"},
    {key: "IA",text: "Iowa",label: "Iowa"},
    {key: "KS",text: "Kansas",label: "Kansas"},
    {key: "KY",text: "Kentucky",label: "Kentucky"},
    {key: "LA",text: "Louisiana",label: "Louisiana"},
    {key: "ME",text: "Maine",label: "Maine"},
    {key: "MH",text: "Marshall Islands",label: "Marshall Islands"},
    {key: "MA", text: "Massachusetts", label : "Massachusetts"},
    {key: "MI",text: "Michigan",label: "Michigan"},
    {key: "MN",text: "Minnesota",label: "Minnesota"},
    {key: "MD", text: "Maryland", label : "Maryland"},
    {key: "MS",text: "Mississippi",label: "Mississippi"},
    {key: "MO",text: "Missouri",label: "Missouri"},
    {key: "MT",text: "Montana",label: "Montana"},
    {key: "NE",text: "Nebraska",label: "Nebraska"},
    {key: "NH",text: "New Hampshire",label: "New Hampshire"},
    {key: "NJ",text: "New Jersey",label: "New Jersey"},
    {key: "NM",text: "New Mexico",label: "New Mexico"},
    {key: "NY",text: "New York",label: "New York"},
    {key: "NV",text: "Nevada",label: "Nevada"},
    {key: "NC",text: "North Carolina",label: "North Carolina"},
    {key: "ND",text: "North Dakota",label: "North Dakota"},
    {key: "NI",text: "Northern Mariana Islands",label: "Northern Mariana Islands"},
    {key: "OH",text: "Ohio",label: "Ohio"},
    {key: "OK",text: "Oklahoma",label: "Oklahoma"},
    {key: "OR",text: "Oregon",label: "Oregon"},
    {key: "PU",text: "Palau",label: "Palau"},
    {key: "PA",text: "Pennsylvania",label: "Pennsylvania"},
    {key: "PR",text: "Puerto Rico",label: "Puerto Rico"},
    {key: "RI", text: "Rhode Island", label : "Rhode Island"},
    {key: "SC",text: "South Carolina",label: "South Carolina"},
    {key: "SD",text: "South Dakota",label: "South Dakota"},
    {key: "TN",text: "Tennessee",label: "Tennessee"},
    {key: "TX",text: "Texas",label: "Texas"},
    {key: "UT",text: "Utah",label: "Utah"},
    {key: "VT", text: "Vermont", label : "Vermont"},
    {key: "VI",text: "Virgin Islands",label: "Virgin Islands"},
    {key: "VA",text: "Virginia",label: "Virginia"},
    {key: "WA",text: "Washington",label: "Washington"},
    {key: "WV", text: "West Virginia", label : "West Virginia"},
    {key: "WI",text: "Wisconsin",label: "Wisconsin"},
    {key: "WY",text: "Wyoming",label: "Wyoming"}
];
const AcornExcludestateList = [
    {key: "NV", text: "Nevada", label : "Nevada"},
    {key: "MA", text: "Massachusetts", label : "Massachusetts"},
    {key: "RI", text: "Rhode Island", label : "Rhode Island"}
];
const loanPurposePopupList = [{ key: "Select", text: "Please select ...", label: "Please select ...", index: "0" },
    { key: "CONSOLIDATE_DEBT", text: "Debt Consolidation", label: "Debt Consolidation", index: "1" },
    { key: "HOME_IMPROVEMENT", text: "Home Improvement", label: "Home Improvement", index: "2" },
    { key: "MEDICAL_EXPENSE", text: "Medical Expense", label: "Medical Expense", plKey: "MEDICAL", index: "3" },
    { key: "AUTO_EXPENSE", text: "Auto Expense", label: "Auto Expense", plKey: "AUTO", index: "4" },
    { key: "OTHER", text: "Other", label: "Other", index: "11" }
    ];

const creditScoreList = [{ key: "720–850", text: "Excellent", label: "720–850", index: "1" },
{ key: "680–719", text: "Good", label: "680–719", index: "2" },
{ key: "620–679", text: "Average", label: "620–679", index: "3" },
{ key: "350–619", text: "Poor", label: "below 620", index: "4" },
];

// const creditScoreList = [{ key: "720–850", text: "Excellent", label: "Excellent (720–850)", index: "1" },
// { key: "680–719", text: "Good", label: "Good (680–719)", index: "2" },
// { key: "620–679", text: "Average", label: "Average (620–679)", index: "3" },
// { key: "350–619", text: "Poor", label: "Poor (below 620)", index: "4" },
// ];

const sortByList = [{ key: "average_apr", text: "Est. APR*", label: "Est. APR*" },
{ key: "monthly_payment", text: "Est. monthly payment*", label: "Est. monthly payment*" },
{ key: "credit_score", text: "Min credit score", label: "Min credit score" }];

const defaultVaules = {
    loanamount: "10000",
    loanPurpose: "HOME_IMPROVEMENT",
    creditScore: "680–719", // Good
    sortBy: "average_apr",
    state: "all",
    annualIncome: "70000"
}

const ProductTypes = { 
    PersonalLoan : 'Personal Loan',
    PersonalCreditLine: 'Personal Credit Line',
    HomeEquityInvestment: 'Home Equity Investment',
    HomeEquityLoans: 'Home Equity Loans'
}
const sortByOfferList1 = [
    { key: "select", text: "Select", label: "Select" },
    { key: "apr_l_h", text: "APR (Low to High)", label: "APR (Low to High)" },
    { key: "term_l_h", text: "Term/Payoff (Low to High)", label: "Term/Payoff (Low to High)" },
    { key: "term_h_l", text: "Term/Payoff (High to Low)", label: "Term/Payoff (High to Low)" },
    { key: "loanamount_l_h", text: "Amount (Low to High)", label: "Amount (Low to High)" },
    { key: "loanamount_h_l", text: "Amount (High to Low)", label: "Amount (High to Low)" }    
   ];  

export { loanPurposeList, creditScoreList, defaultVaules, sortByList,sortByOfferList1, loanPurposePopupList,stateList,AcornExcludestateList, ProductTypes };


// WEBPACK FOOTER //
// ./src/AppData.js